var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8972 24.0847C24.9394 19.4201 24.9169 15.1282 24.9732 11.0264C20.3115 11.0742 16.011 11.0446 11.916 11.1023C11.9019 12.1696 11.8977 12.9825 11.8836 14.002C14.6806 13.9879 17.572 13.9767 19.9977 13.964L11.2298 22.7333C10.9613 23.0019 10.9598 23.4884 11.2256 23.7556L12.2452 24.7751C12.5123 25.0423 12.9989 25.0409 13.2675 24.7709L22.0353 16.0017C22.0114 18.7031 22.0268 21.406 21.9889 24.1074C22.9733 24.1074 24.035 24.0863 24.8956 24.0835L24.8972 24.0847Z",
    fill: "#D8D8D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.5d033fc388ad4363c12b7ba7d79398a4.svg";
export { ForwardRef as ReactComponent };